import Soccer from "./Soccer";

export default Soccer;